import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'

import Alert from '@vtex/styleguide/lib/Alert'

import ItemCardArray from './ItemCardArray'

export const ItemCardList = ({
  items,
  error,
  showPrice,
  handleChangeItemQuantity,
  handleRemoveItem,
  clearError,
}) => {
  return (
    <React.Fragment>
      <span className="self-start pt7">
        <FormattedMessage id="returnExchange.identify.products" />
      </span>
      {error && (
        <div className="pt5 br2">
          <Alert type={error.type} onClose={clearError}>
            <span>{error.message}</span>
          </Alert>
        </div>
      )}
      <div className="bt3">
        <ItemCardArray
          items={items}
          showPrice={showPrice}
          handleChangeItemQuantity={handleChangeItemQuantity}
          handleRemoveItem={handleRemoveItem}
        />
      </div>
    </React.Fragment>
  )
}

ItemCardList.propTypes = {
  items: PropTypes.array,
  error: PropTypes.object,
  showPrice: PropTypes.bool,
  handleRemoveItem: PropTypes.func.isRequired,
  handleChangeItemQuantity: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
}

export default injectIntl(ItemCardList)
